import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo-container">
          <img src="/images/logo.png" alt="Gener8ions Church" className="logo" />
        </Link>

        <button 
          className={`mobile-menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
          <Link 
            to="/" 
            className={isActive('/') ? 'active' : ''}
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={isActive('/about') ? 'active' : ''}
            onClick={() => setIsMenuOpen(false)}
          >
            Who We Are
          </Link>
          <Link 
            to="/sermons" 
            className={isActive('/sermons') ? 'active' : ''}
            onClick={() => setIsMenuOpen(false)}
          >
            Sermons
          </Link>
          <Link 
            to="/services" 
            className={isActive('/services') ? 'active' : ''}
            onClick={() => setIsMenuOpen(false)}
          >
            Services
          </Link>
          <Link 
            to="/announcements" 
            className={isActive('/announcements') ? 'active' : ''}
            onClick={() => setIsMenuOpen(false)}
          >
            Announcements
          </Link>
          <Link 
            to="/give" 
            className={isActive('/give') ? 'active' : ''}
            onClick={() => setIsMenuOpen(false)}
          >
            Give
          </Link>
          <Link 
            to="/contact" 
            className={isActive('/contact') ? 'active' : ''}
            onClick={() => setIsMenuOpen(false)}
          >
            Contact
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;

